// store/attribution.ts
import { create } from 'zustand';

type AttributionStore = {
  pid?: string;
  c?: string;
  firstOpenTracked: boolean;
  setAttribution: (pid?: string, c?: string) => void;
  markTracked: () => void;
};

export const useAttributionStore = create<AttributionStore>((set) => ({
  pid: undefined,
  c: undefined,
  firstOpenTracked: false,
  setAttribution: (pid, c) => set({ pid, c }),
  markTracked: () => set({ firstOpenTracked: true }),
}));
